import { render, staticRenderFns } from "./CreateProfile.vue?vue&type=template&id=cd8e48f8&scoped=true&"
import script from "./CreateProfile.vue?vue&type=script&lang=js&"
export * from "./CreateProfile.vue?vue&type=script&lang=js&"
import style0 from "./CreateProfile.vue?vue&type=style&index=0&id=cd8e48f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8e48f8",
  null
  
)

export default component.exports